export const enI18n = {
  error_title: "OOPS!",
  error_tip1: "lost the page! ",
  error_tip2: "Refresh to find it?",
  error_fresh: "Refresh",
};
export const zhI18n = {
  error_title: "抱歉呀，",
  error_tip1: "当前页面暂时无法正常展示",
  error_tip2: "",
  error_fresh: "刷新一下",
};

export const getTranslateNsT = (local: "zh" | "en") => {
  return (key: string) =>
    ({
      zh: zhI18n,
      en: enI18n,
    }[local][key] || "");
};
